import { Injectable, inject, effect } from '@angular/core';
import { StorageService } from './storage.service';

declare global {
  interface Window {
    Engage: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class EngageService {
  private readonly storage = inject(StorageService);

  // private waitForEngage(): Promise<void> {
  //   return new Promise((resolve) => {
  //     if (window.Engage && window.Engage.init) {
  //       resolve();
  //       return;
  //     }

  //     const check = () => {
  //       if (window.Engage && window.Engage.init) {
  //         resolve();
  //       } else {
  //         setTimeout(check, 100);
  //       }
  //     };
  //     check();
  //   });
  // }

  // Ensure Engage is ready
  private async ensureEngageReady(): Promise<void> {
    // await this.waitForEngage();
  }

  async identify(user: any) {
    // try {
    //   await this.ensureEngageReady();
    //   if (user && window.Engage?.identify) {
    //     window.Engage.identify({
    //       id: user.userID?.toString() || user.emailAddress,
    //       email: user.emailAddress,
    //       last_name: user.family,
    //       first_name: user.name,
    //       number: user.mobileNumber,
    //       created_at: user.birthDate || new Date().toISOString(),
    //     });
    //   }
    // } catch (error) {
    // }
  }

  async trackSignup(user: any, registrationData?: any) {
    // try {
    //   await this.ensureEngageReady();
    //   if (window.Engage?.track) {
    //     this.identify(user);
    //     // Add a small delay to ensure identify is processed
    //     setTimeout(() => {
    //       window.Engage.track(user.emailAddress || user.userID, {
    //         event: 'Sign up',
    //         properties: {
    //           ...user,
    //           registrationData: registrationData
    //             ? {
    //                 ...registrationData,
    //                 password: '[HIDDEN]',
    //                 confirmPassword: '[HIDDEN]',
    //               }
    //             : undefined,
    //         },
    //       });
    //     }, 200);
    //   }
    // } catch (error) {
    // }
  }

  async trackLogin(user: any) {
    // try {
    //   await this.ensureEngageReady();
    //   if (window.Engage?.track) {
    //     this.identify(user);
    //     setTimeout(() => {
    //       window.Engage.track(user.emailAddress || user.userID, {
    //         event: 'Login',
    //         properties: { user: JSON.stringify(user) },
    //       });
    //     }, 200);
    //   }
    // } catch (error) {
    // }
  }

  async trackVerification(email: string) {
    // try {
    //   await this.ensureEngageReady();
    //   if (window.Engage?.track) {
    //     window.Engage.track(email, {
    //       event: 'Email verification',
    //     });
    //   }
    // } catch (error) {
    // }
  }

  async trackEvent(eventName: string, properties?: any) {
    // try {
    //   const user = this.storage.get('user');
    //   await this.ensureEngageReady();
    //   if (user && window.Engage?.track) {
    //     window.Engage.track(user.emailAddress || user.userID, {
    //       event: eventName,
    //       properties,
    //     });
    //   }
    // } catch (error) {
    // }
  }

  async addAttribute(attrs: Record<string, any>) {
    // try {
    //   const user = this.storage.get('user');
    //   await this.ensureEngageReady();
    //   if (user && window.Engage?.addAttribute) {
    //     window.Engage.addAttribute(
    //       user.userID?.toString() || user.emailAddress,
    //       attrs
    //     );
    //   }
    // } catch (error) {
    // }
  }

  // New method to track specific events from your app
  async trackBookingEvent(eventName: string, bookingData: any) {
    // const user = this.storage.get('user');
    // await this.trackEvent(eventName, {
    //   ...bookingData,
    //   userId: user?.userID,
    //   userEmail: user?.emailAddress,
    //   timestamp: new Date().toISOString(),
    // });
  }

  // Track passenger verification
  async trackPassengerVerification(email: string, user: any, success: boolean) {
    // try {
    //   await this.ensureEngageReady();
    //   if (window.Engage?.track) {
    //     const eventName = success
    //       ? 'Successful Passenger Verification'
    //       : 'Failed Passenger Verification';
    //     window.Engage.track(email, {
    //       event: eventName,
    //       properties: { user: JSON.stringify(user) },
    //     });
    //   }
    // } catch (error) {
    // }
  }

  // In your engage.service.ts, add these methods:

  async trackPaymentSuccess(paymentData: any, bookingData?: any) {
    // try {
    //   await this.ensureEngageReady();
    //   const user = this.storage.get('user');
    //   if (user && window.Engage?.track) {
    //     window.Engage.track(user.emailAddress || user.userID, {
    //       event: 'Payment Success',
    //       properties: {
    //         paymentMethod: paymentData.paymentMethod || 'Transfer',
    //         amount: paymentData.amount,
    //         reference: paymentData.reference,
    //         currency: paymentData.currency || 'NGN',
    //         bookingId: paymentData.bookingId,
    //         timestamp: new Date().toISOString(),
    //         ...bookingData,
    //       },
    //     });
    //   }
    // } catch (error) {
    // }
  }

  async trackBookingSuccess(bookingData: any) {
    // try {
    //   await this.ensureEngageReady();
    //   const user = this.storage.get('user');
    //   if (user && window.Engage?.track) {
    //     window.Engage.track(user.emailAddress || user.userID, {
    //       event: 'Booking Success',
    //       properties: {
    //         ...bookingData,
    //         timestamp: new Date().toISOString(),
    //         userId: user.userID,
    //         userEmail: user.emailAddress,
    //       },
    //     });
    //   }
    // } catch (error) {
    // }
  }
}
